import { BaseService } from '#services/BaseService';
import { http } from '#utils/axios';

class RequestLogService extends BaseService {
  getItem = async (id, { includeResponseBody } = {}) => {
    const { data } = await http({
      params: includeResponseBody ? { includeResponseBody: true } : undefined,
      url: `${this.endpoint}/${id}`
    });

    return data;
  };

  constructor() {
    super('/request-log');
    if (!RequestLogService.instance) {
      RequestLogService.instance = this;
    }
    return RequestLogService.instance;
  }
}

const instance = new RequestLogService();
Object.freeze(instance);

export default instance;
